/* ── CLOCK ── */
const cfg = window.FWS || {};

async function getTemp() {
  if (!cfg.showTemp) return '';
  try {
    const r = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=${cfg.lat}&longitude=${cfg.lng}&current=temperature_2m&temperature_unit=fahrenheit`
    );
    const d = await r.json();
    return Math.round(d.current.temperature_2m) + '°F';
  } catch { return '--°F'; }
}

function tick(temp) {
  document.querySelectorAll('.fws-clock').forEach(el => {
    if (!cfg.showClock) { el.style.display = 'none'; return; }
    const now = new Date();
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: cfg.tz || 'America/New_York',
      month: '2-digit', day: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true
    }).formatToParts(now);
    const p = {};
    parts.forEach(x => p[x.type] = x.value);
    const tempStr = temp ? ` ${temp}` : '';
    const cityStr = cfg.city ? ` ${cfg.city}` : '';
    el.textContent = `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}${p.dayPeriod.toLowerCase()}${tempStr}${cityStr}`;
  });
}

let _temp = '';
getTemp().then(t => { _temp = t; tick(_temp); });
setInterval(() => tick(_temp), 1000);
setInterval(() => getTemp().then(t => { _temp = t; }), 600000);

/* ── PRODUCT THUMBNAILS ── */
document.querySelectorAll('.product-thumbnails img').forEach(img => {
  img.addEventListener('click', () => {
    const main = document.getElementById('main-product-img');
    if (main) { main.src = img.src; main.srcset = ''; }
  });
});
